import { render, staticRenderFns } from "./FeeTypeTree.vue?vue&type=template&id=6f54b694&scoped=true"
import script from "./FeeTypeTree.vue?vue&type=script&lang=js"
export * from "./FeeTypeTree.vue?vue&type=script&lang=js"
import style0 from "./FeeTypeTree.vue?vue&type=style&index=0&id=6f54b694&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f54b694",
  null
  
)

export default component.exports